var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-item"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),(!_vm.readonly)?_c('CloseCircleIcon',{staticClass:"icon",attrs:{"fillColor":"#F3F3F2"},on:{"click":_vm.onClickDelete}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }